<template>
  <VPopup
      position="bottom"
      align="right"
      show-pointer
      :offset="21"
      :visible="true"
      :target="target"
  >
    <VDataGridV2
        :data="payments"
        :loading="loading"
    >
      <VDataGridColumnV2
        id="id"
        width="90px"
      >
        <template #label>
          <div>В заявке</div>
          <div class="description">Номер КСЗ</div>
        </template>
        <template #default="{ row }">
          <VLink
            class="nowrap"
            @click="openPaymentCard(row.paymentRequest.id)"
          >
            {{ row.paymentRequest.id ? $core.utils.string.formatWithDelimiter(row.paymentRequest.id) : '--' }}
          </VLink>
          <div class="description">
            {{ row.paymentRequest.externalNumber || '--' }}
          </div>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        label="Плательщик"
        width="110px"
      >
        <template #default="{ row }">
          {{ row.paymentRequest.payer?.name || '--' }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="plannedPaymentDate"
        width="110px"
        content-align="center"
      >
        <template #label>
          <div>Дата оплаты</div>
          <div class="description">План</div>
        </template>
        <template #default="{ row }">
          {{ row.paymentRequest.plannedPaymentDate?.format() || '--' }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="actualPaymentDate"
        width="110px"
        content-align="center"
      >
        <template #label>
          <div>Дата оплаты</div>
          <div class="description">Факт</div>
        </template>
        <template #default="{ row }">
          <template v-if="row.paymentRequest.actualPaymentDate">
            <div
              :class="row.paymentRequest.isOverdue ? 'warning' : 'success'"
            >
              {{ row.paymentRequest.actualPaymentDate.format() }}
            </div>
            <div class="description">
              {{ row.paymentRequest.isOverdue ? 'Просрочено' : 'Вовремя' }}
            </div>
          </template>
          <template v-else>
            <div>--</div>
            <div class="description">Не оплачено</div>
          </template>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="sumFullSeller"
        width="130px"
        content-align="right"
        content-class="nowrap"
      >
        <template #label>
          <div>По позиции</div>
          <div class="description">Сумма платежа</div>
        </template>
        <template #default="{ row }">
          <div class="nowrap">
            {{ row.sumFullSeller.format(row.paymentRequest.orderCurrencyCode) }}
          </div>
          <div class="description">
            {{ row.paymentRequest.sumFull.format(row.paymentRequest.orderCurrencyCode) }}
          </div>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="status"
        label="Статус платежа"
        width="140px"
        content-align="center"
        content-class="nowrap"
      >
        <template #default="{ row }">
          <div
            :class="row.paymentRequest.displayStatusModifier"
          >
            {{ row.paymentRequest.displayStatusText }}
          </div>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="reasonText"
        label="Основание"
        width="120px"
        content-class="nowrap ellipsis"
      >
        <template #default="{ row }">
          <template v-if="row.paymentRequest.reasonText">
            <div
              :title="row.paymentRequest.reasonText"
              class="ellipsis">
              {{ row.paymentRequest.reasonText }}
            </div>
          </template>
          <template v-else-if="row.paymentRequest.orderPosition">
            <div>
              Позиция заказа № {{ $core.utils.string.formatWithDelimiter(row.paymentRequest.orderPosition.id, 4) }}
            </div>
            <div class="description">
              {{ $core.utils.date.format(row.paymentRequest.orderPosition.createdAt) }}
            </div>
          </template>
          <template v-else>
            <div>--</div>
          </template>
        </template>
      </VDataGridColumnV2>
    </VDataGridV2>
  </VPopup>
</template>

<script lang="ts">

import type OrderPosition         from '@/domains/Orders/OrderPosition';
import PaymentRequestPosition     from '@/domains/PaymentRequests/PaymentRequestPosition';
import PaymentRequestsService     from '@/domains/PaymentRequests/PaymentRequestsService';

export default defineComponent({
  name: 'OrderPositionPaymentsPopup',

  props: {
    position: {
      type:    Object as PropType<OrderPosition>,
      default: null,
    },
    target: {
      type:    HTMLElement,
      default: null,
    },
  },

  data() {
    return {
      payments: [] as PaymentRequestPosition[],
      loading:  false,
    };
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      this.loading = true;
      this.payments = await PaymentRequestsService.getPositionPayments(this.position);
      this.loading = false;
    },

    openPaymentCard(id: number): void {
      this.$core.dialogs.OrderPositionPaymentsPopup.hide();
      PaymentRequestsService.showCard(id);
    },
  },
});
</script>
